<template >
  <base-dialog-form ref="editPaymentDialog" :title="computedTitle" color="secondary" icon="mdi-cash-register">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveModPag" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteModPag" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <form>
      <v-row>
        <v-col md="6" cols="12" class="text-center">
          <v-row>
            <v-col md="10" cols="6">
              <v-text-field v-model="payData.descr" :disabled="method === 'VIEW'" :label="$t('name')" :rules="required"
                hide-details="auto"></v-text-field>
            </v-col>
            <v-col md="2" cols="6">
              <v-switch :disabled="method === 'VIEW'" v-model="payData.attivo" :label="$t('active_m_s')"></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="6" cols="12" class="text-center">
          <my-img-uploader ref="imageUploader" v-model="payData.logo" :readOnly="method === 'VIEW'" :width="600"
            :height="120" :placeholder="$t('click_drag_here')"></my-img-uploader>
        </v-col>
        <v-col md="3" cols="6" class="text-center">
          <v-checkbox :disabled="method === 'VIEW'" :false-value="0" :true-value="1" v-model="payData.dataModificabile"
            :label="$t('can_change_data')"></v-checkbox>
        </v-col>

        <v-col md="3" cols="6" class="text-center">
          <v-checkbox :disabled="method === 'VIEW'" :false-value="0" :true-value="1" v-model="payData.online"
            :label="$t('online')"></v-checkbox>
        </v-col>
        <v-col md="3" cols="6" class="text-center">
          <v-select v-if="payData.online === 1" v-model="payData.url" item-value="url" item-text="descr"
            :items="listOnlinePay" :disabled="method === 'VIEW'" :label="$t('type_online_payment')" required
            color="primary" persistent-hint></v-select>
          <v-checkbox v-else :disabled="method === 'VIEW'" :false-value="0" :true-value="1"
            v-model="payData.autoConfirmed" :label="$t('auto_confirmed')"></v-checkbox>
        </v-col>
        <v-col md="3" cols="6">
          <DHMS-picker v-model="payData.timeExpire" :disabled="method === 'VIEW'"
            :label="$t('time_before_pag_expire_with_0')" hide-details="auto"></DHMS-picker>
        </v-col>

        <v-col cols="12" class="text-center">
          <v-autocomplete v-model="payData.codePdc" item-value="code" item-text="dex" :items="listMastriNota"
            :disabled="method === 'VIEW'" :menu-props="{ maxHeight: '400' }" :label="$t('pdc_pagamento')" color="primary"
            persistent-hint></v-autocomplete>
        </v-col>
        <v-col cols="4" class="text-center">
          <v-autocomplete v-model="payData.codeCommissioni" item-value="code" item-text="dex" :items="listMastriFornitori"
            :disabled="method === 'VIEW'" :menu-props="{ maxHeight: '400' }" :label="$t('pdc_commissioni')"
            color="primary" persistent-hint></v-autocomplete>
        </v-col>
        <v-col cols="3" class="text-center">
          <v-select :disabled="method === 'VIEW'" v-model="payData.cdxCommissioni" item-value="cdxId" item-text="descr"
            :items="listCdc" :menu-props="{ maxHeight: '400' }" :label="$t('cdc')" color="primary"
            persistent-hint></v-select>
        </v-col>
        <v-col cols="2" class="text-center">
          <v-text-field v-model="payData.formulaCommissioni" :disabled="method === 'VIEW'"
            :label="$t('formula_commissioni')" hide-details="auto"></v-text-field>
        </v-col>
        <v-col md="3" cols="6" class="text-center">
          <v-checkbox :disabled="method === 'VIEW'" :false-value="0" :true-value="1" v-model="payData.customerFees"
            :label="$t('customers_pay_fees')"></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          {{ $t("instruction") }}

          <tiptap-vuetify :extensions="extensions" :disabled="method === 'VIEW'"
            v-model="payData.istruzioni"></tiptap-vuetify>
        </v-col>
      </v-row>
    </form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyImageUploader from "@/components/base/MyImageUploader.vue";
import DHMSpicker from "@/components/base/DHMSpicker.vue";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";
export default {
  name: "edit-payment",

  components: { "my-img-uploader": MyImageUploader, TiptapVuetify, "DHMS-picker": DHMSpicker },
  data() {
    return {
      pagId: null,
      method: null,
      listCdc: [],
      listMastriNota: [],
      listMastriFornitori: [],
      listOnlinePay: [{ url: "payPal", descr: "paypal" }, { url: "stripe", descr: "stripe" }],
      payData: {},
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
    };
  },
  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_payment");
      else if (this.method === "VIEW") return this.$t("view_payment");
      else if (this.method === "ADD") return this.$t("create_payment");
      else return "";
    },
  },
  methods: {
    open(method, pagId) {
      this.method = method;
      this.pagId = pagId;
      this.loadData();
      this.$refs.editPaymentDialog.open();
    },
    loadData() {
      let _ = this;
      _.listCdc = [];
      _.chiamataAxios("GET", "/auth/contab/listCdx").then((response) => {
        _.listCdc = response.data.cdc;
      });
      _.listMastriNota = [];
      _.chiamataAxios("GET", "/auth/contab/listMastriNota").then((response) => {
        _.listMastriNota = response.data;
      });

      _.listMastriFornitori = [];
      _.chiamataAxios("GET", "/auth/contab/listMastriFornitori").then(
        (response) => {
          _.listMastriFornitori = response.data;
        }
      );

      if (_.pagId !== null) {
        let url = "/auth/portal/getModPagamento/" + _.pagId;
        _.chiamataAxios("GET", url).then((response) => {
          _.payData = response.data;
        });
      } else {
        _.payData = {};
      }
    },
    deleteModPag(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios("DELETE", "/auth/portal/deleteModPag/" + _.pagId, {
            msg: "always",
          }).then((response) => {
            if (response.msg.esito) {
              _.$emit("isUpdated", "true");
              _.$refs.editPaymentDialog.close();
            }
          });
        }
      });
    },
    saveModPag: function () {
      let _ = this;
      let url = "/auth/portal/updateModPag/" + _.pagId;
      let pagObj = _.payData;
      let method = "POST";
      if (_.method == "ADD") {
        url = "/auth/portal/createModPag";
        method = "PUT";
      }
      _.$refs.imageUploader.updateImage();
      _.chiamataAxios(method, url, { body: pagObj }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>";
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$emit("isUpdated", "true");
          _.$refs.editPaymentDialog.close();
        }
      });
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    pagId: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>